import React, { Component } from "react";
import { Popup } from "react-leaflet";

class WinterMaintenceSensorRoutePoupup extends Component {
  render() {
    const { unit, isDump, isDump2, isSand } = this.props;

    return (
      <Popup className="mapPopup" closeButton={false}>
        <div className="mapPopupContent">
          <div className="contentItem">
            <span className="title">Область</span>
            <span className="data">{unit.areaTitle}</span>
          </div>

          <div className="contentItem">
            <span className="title">Организация</span>
            <span className="data">{unit.parentCompanyTitle}</span>
          </div>

          <div className="contentItem">
            <span className="title">Филиал</span>
            <span className="data">{unit.companyTitle}</span>
          </div>

          <div className="contentItem">
            <span className="title">ТС</span>
            <span className="data">{unit.title}</span>
          </div>

          <div className="contentItem">
            <span className="title">Гос номер</span>
            <span className="">
              <b>
                <a href={`/cars/${unit.id}/intimerange`} target="_blank" rel="noreferrer">
                  {unit.registerNumber}
                </a>
              </b>
            </span>
          </div>

          <div className="contentItem">
            <span className="title">Группы</span>
            <span className="data">
              <div>
                {unit.groups.length === 0
                  ? "Вне групп"
                  : unit.groups.map((x) => {
                      return <div key={x.id}>{x.title}</div>;
                    })}
              </div>
            </span>
          </div>

          {isDump === true ? (
            <div className="contentItem">
              <span className="title">Работа отвала</span>
              <span className="data">{unit.dataRoute.distanceDump1} км</span>
            </div>
          ) : null}

          
          {isDump2 === true ? (
            <div className="contentItem">
              <span className="title">Работа отвала 2</span>
              <span className="data">{unit.dataRoute.distanceDump2} км</span>
            </div>
          ) : null}

          {isSand === true ? (
            <div className="contentItem">
              <span className="title">Работа пескосолераспределителя</span>
              <span className="data">{unit.dataRoute.distanceSand} км</span>
            </div>
          ) : null}
        </div>
      </Popup>
    );
  }
}

export default React.memo(WinterMaintenceSensorRoutePoupup);
